import { Billing } from "components/manage/types/Billing";
import { BillingTypes } from "components/manage/types/BillingTypes";
import { ApiVersion } from "services/httpClient/ApiVersion";
import { HttpClient } from "services/httpClient/HttpClient";

export const BillingApi = {
  list: (companyId: string): Promise<BillingTypes[]> => {
    return HttpClient.get<BillingTypes[]>(
      `billing/productfeetier/${companyId}`,
      true,
      true,
      "",
      ApiVersion.V3
    );
  },
  // Get by Id
  getById: (companyId: string, feeTierId: string): Promise<BillingTypes> => {
    return HttpClient.get<BillingTypes>(
      `billing/productfeetier/${companyId}/${feeTierId}`,
      true,
      true,
      "",
      ApiVersion.V3
    );
  },
  // Create
  create: (companyId: string, billing: Billing): Promise<Billing> => {
    return HttpClient.post<Billing>(
      `billing/productfeetier/${companyId}`,
      billing,
      true,
      true,
      "",
      ApiVersion.V3
    );
  },
  // Update
  update: (companyId: string, feeTierId: string, billing: Billing): Promise<void> => {
    return HttpClient.put<void>(
      `billing/productfeetier/${companyId}/${feeTierId}`,
      billing,
      true,
      true,
      "",
      ApiVersion.V3
    );
  }
  // Delete
  //   delete: (companyId: string, feeTierId: string): Promise<void> => {
  //     return HttpClient.delete<void>(
  //       `billing/productfeetier/${companyId}/${feeTierId}`,
  //       true,
  //       true,
  //       "",
  //       ApiVersion.V3
  //     );
  //   }
};
